<div class="date-button"> 
  <div class="date-button_label" *ngIf="isOrderFilter">Date</div>
    <div class="" [ngClass]="isOrderFilter ? 'date-button_button_order' : 'date-button_button'" (click)="openDateDialog($event)">{{dateFilterButtonText}}      
      <div class="date-button_icon" *ngIf="!isOrderFilter">
        <i class="fas fa-caret-down"></i>
      </div>
      <div class="date-button_order_icon" *ngIf="isOrderFilter">
        <i class="fal fa-chevron-down"></i>
      </div>
    </div>
</div>